var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"headers":_vm.headers,"items":_vm.list,"loading":_vm.loading,"fetch":_vm.fetch,"search":_vm.query,"server-items-length":_vm.pagingMetadata.totalCount ? _vm.pagingMetadata.totalCount : Infinity,"reset-search":_vm.resetSearch,"item-key":"id","options":_vm.options,"update-options":_vm.updateOptions},scopedSlots:_vm._u([{key:"item.logo",fn:function(ref){
var item = ref.item;
return [(item.logo)?_c('v-img',{attrs:{"src":item.logo,"alt":item.name,"max-width":"32"}}):_vm._e()]}},{key:"item.referent",fn:function(ref){
var item = ref.item;
return [(item.referent.id !== undefined)?_c('div',{domProps:{"innerHTML":_vm._s(
          _vm.$options.filters.colorTextWrapper(
            ("" + (item.referent.nomComplet)),
            _vm.query
          )
        )}}):_vm._e()]}},{key:"item.actions",fn:function(ref){
        var item = ref.item;
return [_c('div',{staticClass:"d-flex justify-end"},[_c('create-button',{attrs:{"entity":item},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var on = ref.on;
        var loading = ref.loading;
return [_c('v-btn',{staticClass:"mr-5",attrs:{"text":"","icon":"","loading":loading},on:{"click":on}},[_c('v-icon',[_vm._v(" mdi-pencil ")])],1)]}}],null,true)}),_c('delete-company-button',{attrs:{"entities":[item]}})],1)]}},{key:"bulkDelete",fn:function(ref){
        var selectedEntities = ref.selectedEntities;
        var onSuccess = ref.onSuccess;
return [_c('delete-company-button',{attrs:{"entities":selectedEntities},on:{"success":onSuccess},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var on = ref.on;
        var disabled = ref.disabled;
return [_c('v-btn',_vm._g({attrs:{"disabled":disabled,"text":"","color":"primary"}},on),[_vm._v(_vm._s(_vm.$t("Supprimer")))])]}}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }